export const usersActionTypes = {
	GET_ALL_USERS: "GET_ALL_USERS",
	GET_DEPARTMENTS: "GET_DEPARTMENTS",
};
